import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SrcsetImageComponent } from './srcset-image.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SrcsetImageComponent],
  exports: [SrcsetImageComponent],
})
export class SrcsetImageModule {}
